export const OrderStatusIdentifier = Object.freeze({
  Accepted: 1,
  Processing: 2,
  Fulfilled: 3,
  ReadyToShip: 4,
  ReadyForPickup: 5,
  Complete: 6,
  CancelRequested: 7,
  Cancelled: 8,
  Alert: [1, 2, 3, 4, 5, 6, 7]
})

export const PaymentSummary = Object.freeze({
  Authorized: 0,
  PartiallyPaid: 1,
  Paid: 2,
  Cancelled: 3
})

export const OrderTab = Object.freeze({
  All: 0,
  New: 1,
  NewStorePickup: 2,
  Processing: 3,
  InStockSoon: 4,
  ReadyToShip: 5,
  ReadyForPickup: 6,
  Complete: 7,
  Alerts: 8
})

export const DaysUntilInStockSoon = 3

export const OrderSearchType = Object.freeze({
  ShipmentNumber: 0,
  OrderNumber: 1,
  SkuOrIsbn: 2,
  Email: 3,
  CustomerName: 4
})

export const OrderSortBy = Object.freeze({
  CreatedAt: 'CreatedAt'
})

export const OrderAlertType = Object.freeze({
  UnknownError: 0,
  CancelRequested: 1,
  PaymentFailure: 2,
  TaxExemptionPending: 3,
  TaxExemptionCalculationError: 4,
  TaxCalculationError: 5,
  FulfillmentFailure: 6,
  ModificationError: 7,
  EstimatedTaxCalculationError: 8,
  PaymentUpdated: 9
})
